import './App.css';
import NavBar from './Components/Navbar';
import Intro from './Components/Intro';
import About from './Components/About';
import Skills from './Components/Skills';
import Projects from './Components/Projects';
import Contact from './Components/Contact';
import Loading from './Components/Loading';
import Timeline from './Components/Timeline';
import { useState } from 'react';

function App() {
  const [loading, setLoading] = useState(true);

  return (
    <>
      {loading && <Loading onDone={() => setLoading(false)} />}
      <NavBar />
      <main>
        <Intro />
        <About />
        <Skills />
        <Timeline />
        <Projects />
        <Contact />
      </main>
    </>
  );
}

export default App;